import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { VehicleMessages } from 'src/app/core/messages/vehicle-messages.enum';
import { Utils } from 'src/app/core/resources/utils';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CompaniesService } from '../list-companies.service';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { Fmt } from 'src/app/core/messages/fmt';
import { Company } from 'src/app/core/interfaces/company';
import { BasicCompany } from 'src/app/core/interfaces/basicCompany';
import { AccountService } from 'src/app/modules/account/account.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { AuthService } from 'src/app/core/services/authentication.service';
import { VehiclesService } from '../../vehicles/list-vehicles.service';
import { VehicleDocumentCatalog, VehicleDocumentRequired } from 'src/app/core/interfaces/vehicleDocuments';
import { Global } from 'src/app/core/resources/global';
import { Roles } from 'src/app/core/enums/roles.enum';
import { Companies } from 'src/app/core/resources/companies';
import { SecurityRules, ValidationRule } from 'src/app/core/interfaces/validation-rule';
import { ConfigurationSaaS, ConfigurationSaaSId, RiskProfileConfigData, Setting, SettingId } from 'src/app/core/interfaces/saas-config';
import { FleetLoyalty } from 'src/app/core/interfaces/fleetLoyalty';
import { ReactiveForm } from 'src/app/core/resources/reactive-form';
import { SelectableFleetLoyaltyTypes } from 'src/app/core/enums/selectableFleetTypes.enum';
import { TypeBill } from 'src/app/core/interfaces/typeBill';
import { BasicBillType } from 'src/app/core/interfaces/billingConfiguration';
import { AdditionalCost } from 'src/app/core/interfaces/additionalCost';
import { ApiResponseSiigo, ProductSiigo } from 'src/app/core/interfaces/productSiigo';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { CityService } from '../../city/city.service';
import { forkJoin, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, finalize, map, takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { OpenImgComponent } from 'src/app/shared/open-img/open-img.component';
import { IntegrationEnum } from 'src/app/core/enums/integration.enum';
import { SelectCompanyService } from 'src/app/shared/select-company/select-company.service';
import { RiskProfileService } from 'src/app/core/services/risk-profile.service';
import { RiskProfileBulkBody } from '../list-companies.service';
import { SaasTransportCompany } from 'src/app/core/interfaces/saasTransportCompany';
import { WhoToPay } from 'src/app/core/interfaces/whoToPay';
import { SaasTransportCompanyPolicyFormComponent } from '../saas-transport-company-policy-form/saas-transport-company-policy-form.component';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { CatalogService } from 'src/app/core/services/catalog.service';

interface ApiResponse<T> {
  data: T[];
  error: string;
}

type RiskBucket = 'low' | 'medium' | 'high';
type RiskBucketMap<T> = { [bucket in RiskBucket]: T };

@Component({
  selector: 'app-company-config',
  templateUrl: './company-config.component.html',
  styleUrls: ['./company-config.component.scss']
})
export class CompanyConfigComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  @Input() company: Company;
  @Output() public refreshList: EventEmitter<any> = new EventEmitter();
  formSoatRtm: FormGroup;
  formVehicle: FormGroup;
  formResume: FormGroup;
  formIntegration: FormGroup;
  formSecurityPolicies: FormGroup;
  formFees: FormGroup;
  fleetLoyaltyControl: FormControl = new FormControl([]);
  formFleetLoyalty: FormArray;
  formVehicleDocuments: FormArray;
  listTypeDocuments: VehicleDocumentCatalog[] = [];
  listCurrentDocuments: VehicleDocumentRequired[] = [];
  listFleetTypes: { description: SelectableFleetLoyaltyTypes, code: string }[] = [];
  entitiesFields = ['Admin', 'Driver', 'Owner'];
  entitiesDict = {
    Admin: "Administrador",
    Driver: "Conductor",
    Owner: "Propietario"
  }
  stateFields = ['arl', 'eps', 'driverLicense'];
  stateDict = {
    arl: "ARL",
    eps: "EPS",
    driverLicense: "Licencia de conducción",
    operationalAccreditation: "Acreditación de personal operativo"
  }
  securityFields = ['truora'];
  securityDict = {
    truora: "Estudio de seguridad"
  }
  rules: ValidationRule[] = [];
  listCompanies: BasicCompany[] = [];
  vehicleMessages = VehicleMessages;
  serviceMessages = ServiceMessages;
  settingsToSend: Setting;
  formPublicationByDefault: FormGroup;
  formContainerInspection: FormGroup;
  formVehicleInspection: FormGroup;
  formUseEvidenceToGuides: FormGroup;
  formRouteDetour: FormGroup;
  transportCompanyBlackList: CatalogItem[] = [];
  transportCompanyCatalog: CatalogItem[] = [];
  transportCompanySearchControl: FormControl = new FormControl('');
  formRequiresPreValidation: FormGroup;
  formPrebillRequiresValidation: FormGroup;
  formSatelliteTracking: FormGroup;
  formPaymentConsolidation: FormGroup;
  typeBill: BasicBillType = { code: '', description: '' };
  listTypeBill: TypeBill[] = [];
  listAdditionalServices: AdditionalCost[] = [];
  savingAdditionalServiceProduct = false;
  private _destroy$ = new Subject<void>();
  listProductSiigo: ProductSiigo[] = [];
  pageKey: number = 1;
  pageSize: number = 50;
  messageListTypeBill: string = '';
  messageListAdditionalServices: string = '';
  messageListProductSiigo: string = '';
  isLoadingProducts: boolean = false;
  cityControl: FormControl = new FormControl();
  optionsCity: OptionsAutocomplete = {
    title: 'Buscar ciudad',
    requireFullCity: true,
    showBillingInfo: true,
    appearance: 'outline'
  };
  citySub: Subscription;
  attemps: number = 0;
  // Pestaña "Empresas de transporte": la pastilla elige la empresa y debajo van sus secciones.
  // La empresa viaja en ?transportCompanyId= para no perderse al recargar.
  initialTransportCompanyId: string = null;
  selectedTransportCompanyId: string = null;
  // Sección "Facturación" (tipo de documento y productos Siigo): se carga al abrirla, por empresa.
  billingSectionExpanded: boolean = false;
  billingSectionLoading: boolean = false;
  private billingSectionLoadedFor: string = null;
  // Sección "Contabilidad" de la empresa de transporte: tipo de documento contable (CC).
  accountingSectionExpanded: boolean = false;
  accountingSectionLoading: boolean = false;
  private accountingSectionLoadedFor: string = null;
  listAccountingDocumentTypes: TypeBill[] = [];
  messageListAccountingDocumentTypes: string = '';
  // Aún no se guarda: backend no expone dónde persistirlo ni el valor configurado.
  accountingDocumentType: TypeBill = null;
  incomeConsecutiveControl: FormControl = new FormControl(0, [Validators.required, Validators.min(1)]);
  expenseConsecutiveControl: FormControl = new FormControl(0, [Validators.required, Validators.min(1)]);
  receiptFintechConsecutiveControl: FormControl = new FormControl(0, [Validators.required, Validators.min(1)]);
  private satelliteTrackingSettingExists: boolean = false;
  private prebillRequiresValidationSettingExists: boolean = false;
  formRiskProfile: FormGroup;
  private riskProfileConfigExists: boolean = false;
  loadingRiskCompanies: boolean = false;
  riskCompanies: RiskBucketMap<Company[]> = { low: [], medium: [], high: [] };
  filteredRiskCompanies: RiskBucketMap<Company[]> = { low: [], medium: [], high: [] };
  riskSearch: RiskBucketMap<string> = { low: '', medium: '', high: '' };
  riskSelectedIds: RiskBucketMap<Set<string>> = {
    low: new Set<string>(), medium: new Set<string>(), high: new Set<string>()
  };
  pendingRiskIds: RiskBucketMap<Set<string>> = {
    low: new Set<string>(), medium: new Set<string>(), high: new Set<string>()
  };
  readonly riskBuckets: RiskBucket[] = ['low', 'medium', 'high'];
  riskValueBands: { bucket: RiskBucket, label: string, description: string }[] = [];
  readonly riskBucketLabels: RiskBucketMap<string> = {
    low: 'Riesgo bajo', medium: 'Riesgo medio', high: 'Riesgo alto'
  };
  private allRiskCompanies: Company[] = [];
  private originalRiskBucketById: { [companyId: string]: RiskBucket } = {};
  private savedRiskThreshold: number = null;
  private savedRiskMediumThreshold: number = null;
  private savedTripsRequiredMedium: number = null;
  private savedTripsRequiredHigh: number = null;
  private savedRiskProfileEnabled = true;
  private readonly RISK_BUCKET_BY_ID: { [id: string]: RiskBucket } = { '1': 'low', '2': 'medium', '3': 'high' };
  private readonly DEFAULT_RISK_PROFILE_THRESHOLD = 100000000;
  @ViewChildren(CdkVirtualScrollViewport) private riskViewports: QueryList<CdkVirtualScrollViewport>;
  readonly transportCompaniesTabLabel = 'Empresas de transporte';
  transportCompanies: SaasTransportCompany[] = [];
  billingWhoToPays: WhoToPay[] = [];
  // Utilidades de servicios adicionales (configuración SaaS): lista propia, separada de la de
  // productos Siigo por empresa de transporte (listAdditionalServices).
  basicAdditionalServices: AdditionalCost[] = [];
  selectedTabIndex: number = 0;

  readonly rndcPrefixTypeDict: { [key: string]: string } = {
    manifestId: 'Manifiesto',
    consigmentId: 'Remesa',
    consigmentUrbanId: 'Remesa urbana',
    urbanId: 'Guía urbana',
  };
  tabState: { [key: string]: { loading: boolean; loaded: boolean; error: boolean } } = {
    OperationAndTracking: { loading: false, loaded: false, error: false },
    Security: { loading: false, loaded: false, error: false },
    VehiclesAndDrivers: { loading: false, loaded: false, error: false },
    BillingAndPayments: { loading: false, loaded: false, error: false },
    RiskProfile: { loading: false, loaded: false, error: false },
    TransportCompanies: { loading: false, loaded: false, error: false },
  };
  private readonly tabKeyByLabel: { [label: string]: string } = {
    'Operación y Rastreo': 'OperationAndTracking',
    'Seguridad': 'Security',
    'Vehículos y Conductores': 'VehiclesAndDrivers',
    'Facturación y Contabilidad': 'BillingAndPayments',
    'Perfil de riesgo': 'RiskProfile',
    'Empresas de transporte': 'TransportCompanies',
  };
  private readonly orderedTabKeys = ['OperationAndTracking', 'Security', 'VehiclesAndDrivers', 'BillingAndPayments', 'RiskProfile', 'TransportCompanies'];
  constructor(
    public utils: Utils,
    private snackBarService: SnackBarService,
    private spinner: NgxSpinnerService,
    private companyService: CompaniesService,
    private accountService: AccountService,
    private dialog: MatDialog,
    private global: Global,
    private authService: AuthService,
    private permissionRole: PermissionRole,
    private vehicleService: VehiclesService,
    private formBuilder: FormBuilder,
    private cityService: CityService,
    private catalogService: CatalogService,
    private router: Router,
    private selectCompanyService: SelectCompanyService,
    private riskProfileService: RiskProfileService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.listCompanies = this.accountService.listRegisterCompanies();
    if (!this.company) this.company = this.authService && this.authService.getCompany();
    this.initialTransportCompanyId = this.route.snapshot.queryParams['transportCompanyId'] || null;
    this.initBillingConfiguration();
    this.initCompanyConfig();
    if (this.isPrincipalCompany) {
      this.setSubscriptionCity();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.company && !changes.company.firstChange) {
      this.updateSecurityStudyControlsState();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const shown = this.tabsAndSectionsToShow;
      const requestedTab = this.route.snapshot.queryParams['tab'];
      const requestedKey = requestedTab === 'transport-companies' ? 'TransportCompanies' : null;
      const firstKey = requestedKey && shown[requestedKey]
        ? requestedKey
        : this.orderedTabKeys.find(key => shown[key]);
      if (firstKey) {
        this.selectedTabIndex = this.orderedTabKeys.filter(key => shown[key]).indexOf(firstKey);
        this.loadTab(firstKey);
      }
    });
  }

  getSaasSettings() {
    const settings = this.authService.getSettingsSaasCompany();
    if (settings && settings.length) {
      const ownFleet = settings.find(setting => setting.id === SettingId.OWN_FLEET);
      const publicationByDefault = settings.find(setting => setting.id === SettingId.CREATE_SERVICE_PUBLIC_BY_DEFAULT);
      const requiresPreValidation = settings.find(setting => setting.id === SettingId.REQUIRES_PRE_VALIDATION);
      const prebillRequiresValidation = settings.find(setting => setting.id === SettingId.PREBILL_REQUIRES_VALIDATION);
      const enableContainerInspectionByDocument = settings.find(setting => setting.id === SettingId.ENABLE_CONTAINER_INSPECTION_BY_DOCUMENT);
      const enableContainerInspectionByForm = settings.find(setting => setting.id === SettingId.ENABLE_CONTAINER_INSPECTION_BY_FORM);
      const enableVehicleInspectionByDocument = settings.find(setting => setting.id === SettingId.ENABLE_VEHICLE_INSPECTION_BY_DOCUMENT);
      const enableVehicleInspectionByForm = settings.find(setting => setting.id === SettingId.ENABLE_VEHICLE_INSPECTION_BY_FORM);
      const useEvidenceToGuides = settings.find(setting => setting.id === SettingId.USE_EVIDENCE_TO_GUIDES);

      if (ownFleet) {
        this.formFees = new FormGroup({
          active: new FormControl(!!ownFleet.active),
          id: new FormControl(ownFleet.id),
        });
      }
      if (useEvidenceToGuides) {
        this.formUseEvidenceToGuides = new FormGroup({
          active: new FormControl(!!useEvidenceToGuides.active),
          id: new FormControl(useEvidenceToGuides.id),
        });
      }
      if (publicationByDefault) {
        this.formPublicationByDefault = new FormGroup({
          active: new FormControl(!!publicationByDefault.active),
          description: new FormControl(publicationByDefault.description),
          id: new FormControl(publicationByDefault.id),
        });
      }
      if (enableContainerInspectionByDocument && enableContainerInspectionByForm) {
        const activeByDocument = enableContainerInspectionByDocument.active;
        const activeByForm = enableContainerInspectionByForm.active;
        this.formContainerInspection = new FormGroup({
          active: new FormControl(activeByDocument && activeByForm ? 'Ambos' : activeByDocument ? 'Documento' : 'Formulario'),
          id: new FormControl("containerInspection"),
        });
      }
      if (enableVehicleInspectionByDocument && enableVehicleInspectionByForm) {
        const activeByDocument = enableVehicleInspectionByDocument.active;
        const activeByForm = enableVehicleInspectionByForm.active;
        this.formVehicleInspection = new FormGroup({
          active: new FormControl(activeByDocument && activeByForm ? 'Ambos' : activeByDocument ? 'Documento' : 'Formulario'),
          id: new FormControl("vehicleInspection"),
        });
      }
      if (requiresPreValidation) {
        this.formRequiresPreValidation = new FormGroup({
          active: new FormControl(!!requiresPreValidation.active),
          id: new FormControl(requiresPreValidation.id),
        });
      }
      if (prebillRequiresValidation) {
        this.formPrebillRequiresValidation = new FormGroup({
          active: new FormControl(!!prebillRequiresValidation.active),
          id: new FormControl(prebillRequiresValidation.id),
        });
      }
    }
    // El rastreo satelital automático puede no existir aún para la SaaS: se construye siempre
    // (con valor por defecto) para poder crearlo/editarlo desde el front.
    this.buildSatelliteTrackingForm(settings || []);
    // La consolidación de pagos por archivo PAB se construye siempre (con valor por defecto)
    // para poder editarla (PUT) desde el front.
    this.buildPaymentConsolidationForm(settings || []);
  }

  private buildPaymentConsolidationForm(settings: Setting[]) {
    const existing = settings.find(setting => setting.id === SettingId.CONSOLIDATE_BENEFICIARY_PAYMENTS);
    this.formPaymentConsolidation = new FormGroup({
      id: new FormControl(SettingId.CONSOLIDATE_BENEFICIARY_PAYMENTS),
      description: new FormControl(existing && existing.description ? existing.description : 'Consolidación de pagos al mismo beneficiario en el archivo PAB'),
      active: new FormControl(!!(existing && existing.active)),
    });
  }

  private buildSatelliteTrackingForm(settings: Setting[]) {
    const existing = settings.find(setting => setting.id === SettingId.AUTOMATIC_SATELLITE_TRACKING);
    this.satelliteTrackingSettingExists = !!existing;
    this.formSatelliteTracking = new FormGroup({
      id: new FormControl(SettingId.AUTOMATIC_SATELLITE_TRACKING),
      description: new FormControl(existing && existing.description ? existing.description : 'Rastreo satelital automático'),
      active: new FormControl(!!(existing && existing.active)),
    });
  }

  get canEditSatelliteTracking(): boolean {
    // El toggle de rastreo satelital automático solo es visible para usuarios innovbo.
    return this.permissionRole.isInnovboUser();
  }

  onSubmitSatelliteTracking() {
    const setting: Setting = this.formSatelliteTracking.getRawValue();
    const observer = {
      next: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        this.satelliteTrackingSettingExists = true;
        this.authService.setSettingsSaasCompany();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    };
    this.spinner.show();
    // Si ya existe se actualiza (PUT); si no, se crea (POST).
    const request = this.satelliteTrackingSettingExists
      ? this.authService.changeSettingsSaasCompany(setting)
      : this.authService.registerSettingsSaasCompany([setting]);
    request.subscribe(observer);
  }

  private initRouteDetourForm() {
    if (!this.authService || !this.authService.getConfigurationsSaasCompany() || !this.authService.getConfigurationsSaasCompany().length) {
      this.formRouteDetour = null;
      return;
    }
    const config = this.authService.getConfigurationsSaasCompany().find(c => c && c.id === ConfigurationSaaSId.ROUTE_DETOUR);
    if (!config || !config.enabled) {
      this.formRouteDetour = null;
      return;
    }
    const active = this.utils.getNestedValue(config, 'data.active');
    const metters = this.utils.getNestedValue(config, 'data.metters');
    this.formRouteDetour = new FormGroup({
      active: new FormControl(this.utils.isDefined(active) ? !!active : true),
      metters: new FormControl(this.utils.isDefined(metters) ? metters : 500, [Validators.required, Validators.min(1)]),
    });
    if (!this.formRouteDetour.get('active').value) this.formRouteDetour.get('metters').disable();
  }

  private initTransportCompanyBlackListForm() {
    if (!this.authService || !this.authService.getConfigurationsSaasCompany() || !this.authService.getConfigurationsSaasCompany().length)
      return this.transportCompanyBlackList = [];
    const config = this.authService.getConfigurationsSaasCompany().find(c => c && c.id === ConfigurationSaaSId.TRANSPORT_COMPANY_BLACK_LIST);
    if (!config || !config.enabled)
      return this.transportCompanyBlackList = [];
    const list = this.utils.getNestedValue(config, 'data.list');
    this.transportCompanyBlackList = Array.isArray(list) ? list.slice() : [];
    this.loadTransportCompanyCatalog();
  }

  private loadTransportCompanyCatalog() {
    this.catalogService.getTransportCompanies().subscribe(
      (items: CatalogItem[]) => this.transportCompanyCatalog = items || [],
      () => this.transportCompanyCatalog = []
    );
  }

  private initCompanyConfig() {
    this.initForms();
    if (this.utils.isDefined(this.company.rtmAlertsAndBlocksEnabled) && !this.company.rtmAlertsAndBlocksEnabled) {
      this.formSoatRtm.get('daysToAlertExpirationRTM').disable();
      this.formSoatRtm.get('daysToBlockRTM').disable();
    }
    if (this.utils.isDefined(this.company.soatAlertsAndBlocksEnabled) && !this.company.soatAlertsAndBlocksEnabled) {
      this.formSoatRtm.get('daysToAlertExpirationSOAT').disable();
      this.formSoatRtm.get('daysToBlockSOAT').disable();
    }
  }

  private async initForms() {
    this.getSaasSettings();
    this.initRouteDetourForm();
    this.initTransportCompanyBlackListForm();
    if (this.isPrincipalCompany && this.hasPermissionRiskProfile) this.initRiskProfileForm();
    this.formSoatRtm = new FormGroup({
      daysToAlertExpirationSOAT: new FormControl(
        this.company && this.company.daysToAlertExpirationSOAT ? this.company.daysToAlertExpirationSOAT : null,
        [Validators.required, Validators.min(1)]
      ),
      daysToAlertExpirationRTM: new FormControl(
        this.company && this.company.daysToAlertExpirationRTM ? this.company.daysToAlertExpirationRTM : null,
        [Validators.required, Validators.min(1)]
      ),
      daysToBlockSOAT: new FormControl(
        this.company && this.company.daysToBlockSOAT ? this.company.daysToBlockSOAT : null,
        [Validators.required, Validators.min(1)]
      ),
      daysToBlockRTM: new FormControl(
        this.company && this.company.daysToBlockRTM ? this.company.daysToBlockRTM : null,
        [Validators.required, Validators.min(1)]
      ),
      soatAlertsAndBlocksEnabled: new FormControl(
        this.company && this.utils.isDefined(this.company.soatAlertsAndBlocksEnabled) ? this.company.soatAlertsAndBlocksEnabled : true
      ),
      rtmAlertsAndBlocksEnabled: new FormControl(
        this.company && this.utils.isDefined(this.company.rtmAlertsAndBlocksEnabled) ? this.company.rtmAlertsAndBlocksEnabled : true
      ),
    });
    this.formVehicle = new FormGroup({
      daysToDeactivateVehicle: new FormControl(this.company && this.utils.isDefined(this.company.daysToDeactivateVehicle) ? this.company.daysToDeactivateVehicle : '', [Validators.required, Validators.min(1)])
    });
    this.formResume = new FormGroup({
      allowCreatingWithoutTruora: new FormControl(this.company && this.utils.isDefined(this.company.allowCreatingWithoutTruora) ? !this.company.allowCreatingWithoutTruora : false, [])
    })
    this.formIntegration = new FormGroup({
      monitor: new FormControl(this.company && this.company.gpsConfiguration && this.company.gpsConfiguration.monitor && this.company && this.company.gpsConfiguration && this.company.gpsConfiguration.monitor && this.company.gpsConfiguration.monitor.active)
    });
    this.initSecurityPolicyForm();
  }

  private async loadVehiclesData(): Promise<void> {
    if (this.hasPermissionToChangeFleetLoyalty)
      await this.initFleetLoyaltyForm();
    if (this.hasPermissionEditVehicleDocuments) {
      await this.getDocumentTypes();
      await this.getCompanyDocumentTypes();
      this.formVehicleDocuments = new FormArray([]);
      this.listTypeDocuments.forEach((document) => {
        const currentDocument: VehicleDocumentRequired = this.listCurrentDocuments.find(doc => doc && (doc.id === document.name || doc.id === document.id));
        this.formVehicleDocuments.push(new FormGroup({
          id: new FormControl(document.id ? document.id : document.name),
          active: new FormControl(!!(currentDocument && currentDocument.active)),
          mandatory: new FormControl({ value: !!(currentDocument && currentDocument.mandatory), disabled: !(currentDocument && currentDocument.active) }),
          name: new FormControl(this.vehicleService.getVehicleDocumentName(document.name))
        }));
      });
    }
  }

  private async initFleetLoyaltyForm() {
    if (!this.listFleetTypes.length)
      await this.getCompanyFleetTypes();
    const listFleetLoyalties = await this.getCompanyFleetLoyalties();
    this.formFleetLoyalty = new FormArray([]);
    listFleetLoyalties.forEach((fleetLoyalty) => {
      const formFleetLoyalty: FormGroup = new ReactiveForm(this.formBuilder, this.utils.clone(fleetLoyalty)).form;
      if (formFleetLoyalty.get('appUsageDiscountApplied') && formFleetLoyalty.get('appUsageDiscountPercentage')) {
        if (!this.hasAppUsageDiscountEnabled) {
          formFleetLoyalty.get('appUsageDiscountApplied').disable();
          formFleetLoyalty.get('appUsageDiscountPercentage').disable();
        } else {
          if (!fleetLoyalty.appUsageDiscountApplied) formFleetLoyalty.get('appUsageDiscountPercentage').disable();
          formFleetLoyalty.get('appUsageDiscountPercentage').setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
        }
      }
      if (formFleetLoyalty.get('fastPaymentDiscountApplied') && formFleetLoyalty.get('fastPaymentDiscountPercentage')) {
        if (!this.hasFastPaymentEnabled) {
          formFleetLoyalty.get('fastPaymentDiscountApplied').disable();
          formFleetLoyalty.get('fastPaymentDiscountPercentage').disable();
        } else {
          if (!fleetLoyalty.fastPaymentDiscountApplied) formFleetLoyalty.get('fastPaymentDiscountPercentage').disable();
          formFleetLoyalty.get('fastPaymentDiscountPercentage').setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
        }
      }
      if (formFleetLoyalty.get('quantity')) {
        if (fleetLoyalty && fleetLoyalty.category && fleetLoyalty.category.description !== SelectableFleetLoyaltyTypes.RECURRENT_LOYALTY)
          formFleetLoyalty.removeControl('quantity');
        else formFleetLoyalty.get('quantity').setValidators([Validators.required, Validators.min(1)]);
      }
      this.formFleetLoyalty.push(formFleetLoyalty);
    });
    this.fleetLoyaltyControl.setValue(listFleetLoyalties.map(fleetLoyalty => fleetLoyalty.category));
    if (this.listFleetTypes.length && this.listFleetTypes.length === listFleetLoyalties.length)
      this.fleetLoyaltyControl.disable();
  }

  private async getDocumentTypes() {
    try {
      const types = await this.vehicleService.getDocumentTypes().toPromise();
      if (types && types.catalog && types.catalog.length)
        this.listTypeDocuments = [...this.global.listTypeDocuments, ...types.catalog];
      else
        this.listTypeDocuments = [...this.global.listTypeDocuments];
    } catch (error) {
      this.listTypeDocuments = [...this.global.listTypeDocuments];
    }
  }

  private async getCompanyDocumentTypes() {
    try {
      const types = await this.vehicleService.getCompanyDocumentTypes().toPromise();
      if (types && types.length)
        this.listCurrentDocuments = types;
      else
        this.listCurrentDocuments = [];
    } catch (e) {
      this.listCurrentDocuments = [];
    }
  }

  private async getCompanyFleetTypes() {
    try {
      const fleetTypes = await this.vehicleService.getCompanyFleetTypes().toPromise();
      if (fleetTypes && fleetTypes.catalog && fleetTypes.catalog.length)
        this.listFleetTypes = fleetTypes.catalog.map(fleetType => ({ description: fleetType.name, code: fleetType.id }));
      else
        this.listFleetTypes = [];
    } catch (e) {
      this.listFleetTypes = [];
    }
  }

  private async getCompanyFleetLoyalties(): Promise<FleetLoyalty[]> {
    try {
      const fleetLoyalties = await this.vehicleService.getCompanyFleetLoyalties().toPromise();
      return fleetLoyalties && fleetLoyalties.length ? fleetLoyalties : [];
    } catch (e) {
      return [];
    }
  }

  private async getValidationRules() {
    try { this.rules = await this.vehicleService.getValidationRules().toPromise() }
    catch (error) { this.rules = [] }
  }

  private async initSecurityPolicyForm() {
    await this.getValidationRules();
    if (this.hasEscortServicesCompany && !this.stateFields.includes("operationalAccreditation"))
      this.stateFields.push('operationalAccreditation');

    this.formSecurityPolicies = new FormGroup({});
    this.entitiesFields.forEach((entity: Roles) => {
      const stateControl = new FormGroup({});
      this.stateFields.forEach((state) => {
        const stateRule: ValidationRule = this.rules.find(rule => rule && rule.roleName === entity && rule.ruleType === 'state' && rule.ruleName === state);
        if (stateRule && stateRule.id)
          stateControl.addControl(state, new FormControl(!!stateRule.active));
      })
      const securityControl = new FormGroup({});
      this.securityFields.forEach((security) => {
        const securityRule: ValidationRule = this.rules.find(rule => rule && rule.roleName === entity && rule.ruleType === 'security' && rule.ruleName === security);
        if (securityRule && securityRule.id)
          securityControl.addControl(security, new FormControl(!!securityRule.active));
      });
      const entityControl = new FormGroup({});
      entityControl.addControl("state", stateControl);
      entityControl.addControl('security', securityControl);
      this.formSecurityPolicies.addControl(entity, entityControl);
    });
    this.updateSecurityStudyControlsState();
  }


  private updateSecurityStudyControlsState(): void {
    if (!this.formSecurityPolicies) {
      return;
    }
    this.entitiesFields.forEach((entity: Roles) => {
      const truoraControl = this.formSecurityPolicies.get(entity) &&
        this.formSecurityPolicies.get(entity).get('security') &&
        this.formSecurityPolicies.get(entity).get('security').get('truora');
      if (!truoraControl) {
        return;
      }
      if (this.isSecurityStudyRequired) truoraControl.enable({ emitEvent: false });
      else truoraControl.disable({ emitEvent: false });
    });
  }

  onChangeEnable($event, type: 'RTM' | 'SOAT') {
    const active = this.utils.isDefined($event.value) ? $event.value : $event.checked;
    if (type === 'RTM') {
      active ? this.formSoatRtm.get('daysToAlertExpirationRTM').enable() : this.formSoatRtm.get('daysToAlertExpirationRTM').disable();
      active ? this.formSoatRtm.get('daysToBlockRTM').enable() : this.formSoatRtm.get('daysToBlockRTM').disable();
    } else {
      active ? this.formSoatRtm.get('daysToAlertExpirationSOAT').enable() : this.formSoatRtm.get('daysToAlertExpirationSOAT').disable();
      active ? this.formSoatRtm.get('daysToBlockSOAT').enable() : this.formSoatRtm.get('daysToBlockSOAT').disable();
    }
  }

  onSubmitSoatRtm() {
    this.formSoatRtm.markAllAsTouched();
    if (this.formSoatRtm.invalid) {
      if (this.utils.errorMessagesCustomized(this.formSoatRtm.get('daysToAlertExpirationSOAT'), 'periodo de advertencia del SOAT', null, null, 1)) return;
      else if (this.utils.errorMessagesCustomized(this.formSoatRtm.get('daysToBlockSOAT'), 'periodo de bloqueo del SOAT', null, null, 1)) return;
      else if (this.utils.errorMessagesCustomized(this.formSoatRtm.get('daysToAlertExpirationRTM'), 'periodo de advertencia de la RTM', null, null, 1)) return;
      else if (this.utils.errorMessagesCustomized(this.formSoatRtm.get('daysToBlockRTM'), 'periodo de bloqueo de la RTM', null, null, 1)) return;
      else {
        this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT);
        return;
      }
    }
    const body = this.formSoatRtm.getRawValue();
    body.daysToAlertExpirationSOAT = parseInt(body.daysToAlertExpirationSOAT);
    body.daysToBlockSOAT = parseInt(body.daysToBlockSOAT);
    body.daysToAlertExpirationRTM = parseInt(body.daysToAlertExpirationRTM);
    body.daysToBlockRTM = parseInt(body.daysToBlockRTM);

    if (body.soatAlertsAndBlocksEnabled && body.daysToAlertExpirationSOAT < body.daysToBlockSOAT) {
      this.snackBarService.openSnackBar("El periodo de advertencia debe ser mayor al periodo de bloqueo para el SOAT", undefined, 'alert');
      return
    }
    if (body.rtmAlertsAndBlocksEnabled && body.daysToAlertExpirationRTM < body.daysToBlockRTM) {
      this.snackBarService.openSnackBar("El periodo de advertencia debe ser mayor al periodo de bloqueo para la RTM", undefined, 'alert');
      return
    }
    this.updateAlertsAndBlocks(body);
  }

  updateAlertsAndBlocks(body) {
    this.spinner.show();
    this.companyService.updateAlertsAndBlocks(body, this.company.companyId).subscribe(
      (result: any) => {
        this.spinner.hide();
        this.refreshList.emit();
        this.snackBarService.openSnackBar(result && result.message ? result.message : 'Se actualizaron las alertas y bloqueos exitosamente');
      },
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    )
  }

  onSubmitVehicle() {
    this.formVehicle.markAllAsTouched();
    if (this.formVehicle.invalid) {
      if (this.utils.errorMessagesCustomized(this.formVehicle.get('daysToDeactivateVehicle'), 'máximo de días de inactividad', null, null, 1)) return;
      else {
        this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT);
        return;
      }
    }
    const body = {
      companyId: this.company.companyId,
      daysToDeactivateVehicle: Number(this.formVehicle.value.daysToDeactivateVehicle)
    };
    const deactivateVehicleObserver = {
      next: () => {
        this.spinner.hide();
        this.refreshList.emit();
        this.snackBarService.openSnackBar(FormMessages.DEACTIVATE_VEHICLE_SUCCESS);
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      },
      complete: () => {
        this.spinner.hide();
      }
    };
    this.spinner.show();
    this.companyService.setDaysToDeactivateVehicle(body).subscribe(deactivateVehicleObserver);
  }

  onSubmitFees() {
    this.formFees.markAllAsTouched();
    let setting: Setting = this.formFees.getRawValue();
    const changeSettingSaasCompanyObserver = {
      next: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        this.authService.setSettingsSaasCompany();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      }
    }
    this.spinner.show();
    this.authService.changeSettingsSaasCompany(setting).subscribe(changeSettingSaasCompanyObserver);
  }

  onSubmitPaymentConsolidation() {
    this.formPaymentConsolidation.markAllAsTouched();
    let setting: Setting = this.formPaymentConsolidation.getRawValue();
    const changeSettingSaasCompanyObserver = {
      next: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        this.authService.setSettingsSaasCompany();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      }
    }
    this.spinner.show();
    this.authService.changeSettingsSaasCompany(setting).subscribe(changeSettingSaasCompanyObserver);
  }

  onSubmitUseEvidenceToGuides() {
    this.formUseEvidenceToGuides.markAllAsTouched();
    let setting: Setting = this.formUseEvidenceToGuides.getRawValue();
    const changeSettingSaasCompanyObserver = {
      next: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        this.authService.setSettingsSaasCompany();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      }
    }
    this.spinner.show();
    this.authService.changeSettingsSaasCompany(setting).subscribe(changeSettingSaasCompanyObserver);
  }

  onSubmitRequiresPreValidation(active: boolean) {
    this.formRequiresPreValidation.markAllAsTouched();
    let setting: Setting = this.formRequiresPreValidation.getRawValue();
    setting.active = active;
    const changeSettingSaasCompanyObserver = {
      next: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        this.authService.setSettingsSaasCompany();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      }
    }
    this.spinner.show();
    this.authService.changeSettingsSaasCompany(setting).subscribe(changeSettingSaasCompanyObserver);
  }

  onSubmitPrebillRequiresValidation(active: boolean) {
    this.formPrebillRequiresValidation.markAllAsTouched();
    const setting: Setting = this.formPrebillRequiresValidation.getRawValue();
    setting.active = active;
    const observer = {
      next: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        this.prebillRequiresValidationSettingExists = true;
        this.authService.setSettingsSaasCompany();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      }
    };
    this.spinner.show();
    this.authService.changeSettingsSaasCompany(setting).subscribe(observer);
  }

  private initBillingConfiguration() {
    const billingConfiguration = this.company && this.company.billingConfiguration;
    this.typeBill = billingConfiguration && billingConfiguration.documentTypeId
      ? billingConfiguration.documentTypeId
      : { code: '', description: '' };
  }

  private async getConsecutives() {
    try {
      const receiptResponse = await this.companyService.getConsecutive('Receipt').toPromise();
      const journalResponse = await this.companyService.getConsecutive('Journal').toPromise();
      this.incomeConsecutiveControl.setValue(journalResponse ? journalResponse : 0);
      this.expenseConsecutiveControl.setValue(receiptResponse ? receiptResponse : 0);
    } catch (error) {
      this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los consecutivos'), undefined, 'error');
    }
    if (this.isTeclogiUser) {
      try {
        const receiptFintechResponse = await this.companyService.getConsecutive('ReceiptFintech').toPromise();
        this.receiptFintechConsecutiveControl.setValue(receiptFintechResponse ? receiptFintechResponse : 0);
      } catch (error) {
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'el consecutivo de recibos de LoggiCash'), undefined, 'error');
      }
    }
  }

  get selectedTransportCompany(): SaasTransportCompany {
    return this.transportCompanies.find(company => company && company.companyId === this.selectedTransportCompanyId) || null;
  }

  /**
   * Cambio de empresa en la pastilla de "Empresas de transporte": las secciones
   * muestran la nueva empresa. Si "Facturación" está abierta se recarga ya;
   * si no, al abrirla. Los selects guardan al cambiar: no hay cambios pendientes.
   */
  public onTransportCompanyChange(transportCompanyId: string): void {
    if (transportCompanyId === this.selectedTransportCompanyId) return;
    this.selectedTransportCompanyId = transportCompanyId;
    this.optionsCity.transportNit = transportCompanyId || undefined;
    // Lo escrito en "Productos Siigo – Ciudades" y sus resultados eran de la empresa anterior.
    this.cityControl.setValue('');
    this.syncTransportCompanyInUrl(transportCompanyId);
    this.billingSectionLoadedFor = null;
    this.initTransportCompanyBillingConfiguration();
    if (this.billingSectionExpanded) this.loadBillingSection();
    this.accountingSectionLoadedFor = null;
    this.accountingDocumentType = null;
    if (this.accountingSectionExpanded) this.loadAccountingSection();
  }

  public onAccountingSectionOpened(): void {
    this.accountingSectionExpanded = true;
    this.loadAccountingSection();
  }

  private async loadAccountingSection(): Promise<void> {
    const transportCompanyId = this.selectedTransportCompanyId;
    if (!transportCompanyId || this.accountingSectionLoadedFor === transportCompanyId) return;
    this.accountingSectionLoading = true;
    this.messageListAccountingDocumentTypes = '';
    let documentTypes: TypeBill[] = [];
    let failed = false;
    try {
      documentTypes = await this.companyService.listAccountingDocumentTypes(transportCompanyId).toPromise() || [];
    } catch (error) {
      failed = true;
    }
    // Si se cambió de empresa mientras cargaba, la carga vigente es la de la nueva.
    if (transportCompanyId !== this.selectedTransportCompanyId) return;
    this.listAccountingDocumentTypes = documentTypes;
    if (failed) this.messageListAccountingDocumentTypes = Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los tipos de documento contable');
    else if (!documentTypes.length) this.messageListAccountingDocumentTypes = Fmt.string(ServiceMessages.NO_DATA_FOUND, 'tipos de documento contable');
    this.accountingSectionLoadedFor = transportCompanyId;
    this.accountingSectionLoading = false;
  }

  public onSelectAccountingDocumentType(event: MatSelectChange): void {
    this.accountingDocumentType = event.value;
  }

  public onBillingSectionOpened(): void {
    this.billingSectionExpanded = true;
    this.loadBillingSection();
  }

  private async loadBillingSection(): Promise<void> {
    const transportCompanyId = this.selectedTransportCompanyId;
    if (!transportCompanyId || this.billingSectionLoadedFor === transportCompanyId) return;
    this.billingSectionLoading = true;
    try {
      await this.getServicesAsync();
      // Si se cambió de empresa mientras cargaba, la carga vigente es la de la nueva.
      if (transportCompanyId === this.selectedTransportCompanyId) this.billingSectionLoadedFor = transportCompanyId;
    } finally {
      if (transportCompanyId === this.selectedTransportCompanyId) this.billingSectionLoading = false;
    }
  }

  /** replaceUrl: cambiar de empresa no agrega pasos al historial del navegador. */
  private syncTransportCompanyInUrl(transportCompanyId: string): void {
    if (!transportCompanyId || this.route.snapshot.queryParams['transportCompanyId'] === transportCompanyId) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { transportCompanyId },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  private async getServicesAsync(): Promise<void> {
    const transportCompanyId = this.selectedTransportCompanyId;
    this.listAdditionalServices = [];
    this.messageListTypeBill = '';
    this.messageListAdditionalServices = '';
    this.messageListProductSiigo = '';
    // Reinicia el estado de paginación de productos Siigo para que un refresh
    // vuelva a cargar desde la página 1 (reemplaza) en vez de anexar.
    this.pageKey = 1;
    this.attemps = 0;
    this.listProductSiigo = [];
    return forkJoin([this.getListTypeBill(), this.getListAdditionalServices()])
      .toPromise()
      .then(([typeBillResponse, additionalServicesResponse]) => {
        if (transportCompanyId !== this.selectedTransportCompanyId) return;
        this.processTypeBillResponse(typeBillResponse);
        this.processAdditionalServicesResponse(additionalServicesResponse);
        if (this.listAdditionalServices.length) this.getProductSiigo();
      });
  }

  processTypeBillResponse(typeBillResponse: ApiResponse<TypeBill>): void {
    if (!typeBillResponse || typeBillResponse.error) this.messageListTypeBill = Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los tipos de documentos');
    else if (!typeBillResponse.data || typeBillResponse.data.length === 0) this.messageListTypeBill = Fmt.string(ServiceMessages.NO_DATA_FOUND, 'tipos de documento de factura');
    else this.listTypeBill = typeBillResponse.data;
  }

  processAdditionalServicesResponse(additionalServicesResponse: ApiResponse<AdditionalCost>): void {
    if (!additionalServicesResponse || additionalServicesResponse.error) this.messageListAdditionalServices = Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los servicios adicionales');
    else if (!additionalServicesResponse.data || additionalServicesResponse.data.length === 0) this.messageListAdditionalServices = Fmt.string(ServiceMessages.NO_DATA_FOUND, 'servicios adicionales');
    else this.listAdditionalServices = additionalServicesResponse.data;
  }

  processProductSiigoResponse(productSiigoResponse: ApiResponse<ProductSiigo>, totalResults?: number): void {
    if (!productSiigoResponse || productSiigoResponse.error) this.messageListProductSiigo = Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los productos siigo');
    else if (!productSiigoResponse.data || productSiigoResponse.data.length === 0) this.messageListProductSiigo = Fmt.string(ServiceMessages.NO_DATA_FOUND, 'productos siigo');
    else {
      if (this.pageKey && this.pageKey === 1) this.listProductSiigo = productSiigoResponse.data;
      else this.listProductSiigo = [...this.listProductSiigo, ...productSiigoResponse.data];
      if (totalResults && this.listProductSiigo.length < totalResults && this.attemps < 10) {
        this.pageKey++;
        this.attemps++;
        this.getProductSiigo();
      } else this.attemps = 0;
    }
  }

  getListTypeBill(): Observable<ApiResponse<TypeBill>> {
    return this.companyService.listTypeBill(this.selectedTransportCompanyId).pipe(
      map((data: TypeBill[]) => ({ data, error: '' })),
      catchError((error): Observable<ApiResponse<TypeBill>> => {
        return of({ data: [], error: error });
      })
    );
  }

  getListAdditionalServices(): Observable<ApiResponse<AdditionalCost>> {
    return this.companyService.getAdditionalServices(this.selectedTransportCompanyId).pipe(
      map((data: AdditionalCost[]) => ({ data, error: '' })),
      catchError((error): Observable<ApiResponse<AdditionalCost>> => {
        return of({ data: [], error: error });
      })
    );
  }

  onProductSiigoChange(event: MatSelectChange, index: number) {
    const productSiigoId = event.value;
    this.updateProductSiigoAdditionalService(productSiigoId, this.listAdditionalServices[index]);
  }

  public getProductSiigo() {
    this.isLoadingProducts = true;
    const listProductSiigoObserver = {
      next: (data: ApiResponseSiigo) => {
        const totalResults = this.utils.getNestedValue(data, 'pagination.totalResults');
        this.processProductSiigoResponse({ data: data.results, error: '' }, totalResults);
      },
      error: (error) => {
        this.processProductSiigoResponse({ data: [], error: error });
      }
    };
    this.cityService.getProductSiigo(this.pageKey, this.pageSize, this.selectedTransportCompanyId).pipe(finalize(() => {
      this.isLoadingProducts = false;
    })).subscribe(listProductSiigoObserver);
  }

  onSelectTypeBill(event: MatSelectChange) {
    let code = this.utils.getNestedValue(event.value, 'id');
    let description = this.utils.getNestedValue(event.value, 'description');
    if (code && description) this.updateTypeBillCompany({ code, description });
    else this.snackBarService.openSnackBar("Por favor seleccione un tipo de documento de factura", undefined, 'error');
  }

  updateTypeBillCompany(typeBill: BasicBillType) {
    const updateTypeBillCompanyObserver = {
      next: (response: { message: string }) => {
        if (response && response.message) {
          // code como texto: compareTypeBill compara contra TypeBill.id.toString() (llega numérico del select).
          this.typeBill = { code: String(typeBill.code), description: typeBill.description };
          // Se refleja en la empresa del listado para que, al cambiar de empresa y volver, se vea lo guardado.
          const transportCompany = this.selectedTransportCompany;
          if (transportCompany) transportCompany.billingConfiguration = { ...(transportCompany.billingConfiguration || {}), documentTypeId: { ...this.typeBill } };
          this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.FIELD_UPDATED_SUCCESSFULLY, 'el tipo de documento de factura'), undefined, 'success');
          this.refreshList.emit(true);
        } else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      },
      error: () => {
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    };
    this.spinner.show();
    this.companyService.updateTypeBillCompany({
      documentTypeId: { code: typeBill.code, description: typeBill.description },
      expirationDays: Number(this.utils.getNestedValue(this.company, 'billingConfiguration.expirationDays')),
      requiresPreInvoice: !!this.utils.getNestedValue(this.company, 'billingConfiguration.requiresPreInvoice')
    }, this.company.companyId, this.selectedTransportCompanyId).pipe(finalize(() => this.spinner.hide())).subscribe(updateTypeBillCompanyObserver);
  }

  updateProductSiigoAdditionalService(productSiigoId: string, additionalService: AdditionalCost) {
    if (this.savingAdditionalServiceProduct || !additionalService) return;
    const transportCompanyId = this.selectedTransportCompanyId;
    const services = this.listAdditionalServices;
    const body = this.utils.clone(services) as AdditionalCost[];
    const serviceToUpdate = body.find(service => service.id === additionalService.id);
    if (!serviceToUpdate) return;
    serviceToUpdate.productSiigoId = productSiigoId;
    const request$ = transportCompanyId
      ? this.companyService.saveAdditionalCostsUtilities(body, transportCompanyId)
      : this.companyService.updateProductSiigoAdditionalService(productSiigoId, additionalService.id);
    this.savingAdditionalServiceProduct = true;
    this.spinner.show();
    request$.pipe(takeUntil(this._destroy$), finalize(() => {
      this.savingAdditionalServiceProduct = false;
      this.spinner.hide();
    })).subscribe(
      () => {
        if (transportCompanyId !== this.selectedTransportCompanyId || services !== this.listAdditionalServices) return;
        additionalService.productSiigoId = productSiigoId;
        this.snackBarService.openSnackBar(`${Fmt.string(ServiceMessages.FIELD_UPDATED_SUCCESSFULLY, 'el producto siigo')} del servicio adicional ${additionalService.name}`, undefined, 'success');
      },
      () => {
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    );
  }

  compareTypeBill = (option1: TypeBill, option2: BasicBillType): boolean => {
    if (!option1 || !option2 || !this.utils.isDefined(option1.id) || !option2.code) return false;
    return option1.id.toString() === option2.code && option1.description === option2.description;
  }

  compareProductSiigo = (option1: string, option2: string): boolean => {
    if (!option1 || !option2) return false;
    return option1 === option2;
  }

  openModalCargoPDF(url: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Habilitar factura tipo 12 en Siigo',
      src: url,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(OpenImgComponent, dialogConfig);
  }

  setSubscriptionCity() {
    this.citySub = this.cityControl.valueChanges
      .subscribe(value => {
        if (value && value.id) {
          this.router.navigate(['administration/cities/detail', value.id], {
            state: { byRedirect: true, nitCompany: this.company.companyId },
            ...(this.selectedTransportCompanyId ? { queryParams: { transportCompanyId: this.selectedTransportCompanyId } } : {})
          });
        }
      });
  }

  updateConsecutive(type: 'Receipt' | 'Journal' | 'ReceiptFintech') {
    const control = {
      'Journal': this.incomeConsecutiveControl,
      'Receipt': this.expenseConsecutiveControl,
      'ReceiptFintech': this.receiptFintechConsecutiveControl
    }[type];
    if (!control.value) return this.snackBarService.openSnackBar('Debe ingresar un consecutivo válido', undefined, 'alert');
    this.spinner.show();
    this.companyService.updateConsecutive(type, Number(control.value)).subscribe({
      next: (response) => {
        this.snackBarService.openSnackBar(response && response.message ? response.message : Fmt.string(ServiceMessages.FIELD_UPDATED_SUCCESSFULLY, 'el consecutivo'), undefined, 'success');
        this.getConsecutives();
      },
      error: () => {
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ERROR_UPDATING_DATA, 'el consecutivo'), undefined, 'error');
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

  compareFleetLoyalty(a: { description: SelectableFleetLoyaltyTypes, code: string }, b: { description: SelectableFleetLoyaltyTypes, code: string }) {
    return a.description === b.description;
  }

  disableFleetLoyalty(name: string) {
    return this.formFleetLoyalty && this.formFleetLoyalty.controls && this.formFleetLoyalty.controls.some(fleetLoyalty =>
      fleetLoyalty && fleetLoyalty.get('category') && fleetLoyalty.get('category').value &&
      fleetLoyalty.get('category').value.description === name && fleetLoyalty.get('id') && fleetLoyalty.get('id').value);
  }

  onSelectFleetLoyalty(items: { description: string, code: string }[]) {
    const currentFleetLoyaltyNames: string[] = this.formFleetLoyalty.controls && this.formFleetLoyalty.controls.length
      ? this.formFleetLoyalty.controls.map(fleetLoyalty => this.utils.getNestedValue(fleetLoyalty.value, "category.description"))
      : [];
    items.forEach(item => !currentFleetLoyaltyNames.includes(item.description) && this.onAddFleetLoyalty(item));
    currentFleetLoyaltyNames.forEach((name, index) => !items.some(item => item.description === name) && this.onRemoveFleetLoyalty(index));
  }

  private onAddFleetLoyalty(item: { description: string, code: string }) {
    const formFleetLoyalty = new FormGroup({
      category: new FormControl(item)
    });
    if (this.hasAppUsageDiscountEnabled) {
      formFleetLoyalty.addControl('appUsageDiscountApplied', new FormControl(true));
      formFleetLoyalty.addControl('appUsageDiscountPercentage', new FormControl(0, [Validators.required, Validators.min(0), Validators.max(100)]));
    }
    if (this.hasFastPaymentEnabled) {
      formFleetLoyalty.addControl('fastPaymentDiscountApplied', new FormControl(true));
      formFleetLoyalty.addControl('fastPaymentDiscountPercentage', new FormControl(0, [Validators.required, Validators.min(0), Validators.max(100)]));
    }
    if (item.description === "Fidelizada por recurrencia")
      formFleetLoyalty.addControl('quantity', new FormControl(10, [Validators.required, Validators.min(1)]));
    this.formFleetLoyalty.push(formFleetLoyalty);
  }

  private onRemoveFleetLoyalty(index: number) {
    this.formFleetLoyalty.removeAt(index);
  }

  onChangeEnableFleetLoyalty($event, type: 'appUsageDiscountApplied' | 'fastPaymentDiscountApplied', index: number) {
    const active = this.utils.isDefined($event.value) ? $event.value : $event.checked;
    const field = type === 'appUsageDiscountApplied' ? 'appUsageDiscountPercentage' : 'fastPaymentDiscountPercentage';
    active ? this.formFleetLoyalty.at(index).get(field).setValue(0) : this.formFleetLoyalty.at(index).get(field).setValue(0);
    active ? this.formFleetLoyalty.at(index).get(field).enable() : this.formFleetLoyalty.at(index).get(field).disable();
  }

  async onSubmitFleetLoyalty() {
    this.formFleetLoyalty.markAllAsTouched();
    for (const fleetLoyalty of this.formFleetLoyalty.controls) {
      const name = this.utils.getNestedValue(fleetLoyalty.value, "category.description");
      if (fleetLoyalty.get('appUsageDiscountPercentage') && this.utils.errorMessagesCustomized(fleetLoyalty.get('appUsageDiscountPercentage'), `descuento por uso de la app de la flota ${name.toLowerCase()}`, null, null, 0, 100)) return;
      if (fleetLoyalty.get('fastPaymentDiscountPercentage') && this.utils.errorMessagesCustomized(fleetLoyalty.get('fastPaymentDiscountPercentage'), `descuento por pronto pago de la flota ${name.toLowerCase()}`, null, null, 0, 100)) return;
      if (fleetLoyalty.get('quantity') && this.utils.errorMessagesCustomized(fleetLoyalty.get('quantity'), `cantidad de viajes de la flota ${name.toLowerCase()}`, null, null, 1)) return;
    }
    const fleetLoyalties = this.formFleetLoyalty.getRawValue().map(fleetLoyalty => {
      if ("appUsageDiscountPercentage" in fleetLoyalty) fleetLoyalty.appUsageDiscountPercentage = Number(fleetLoyalty.appUsageDiscountPercentage);
      if ("fastPaymentDiscountPercentage" in fleetLoyalty) fleetLoyalty.fastPaymentDiscountPercentage = Number(fleetLoyalty.fastPaymentDiscountPercentage);
      if ("quantity" in fleetLoyalty) fleetLoyalty.quantity = Number(fleetLoyalty.quantity);
      return fleetLoyalty;
    });
    const fleetsToCreate = fleetLoyalties.filter(fleetLoyalty => !fleetLoyalty.id);
    const fleetsToUpdate = fleetLoyalties.filter(fleetLoyalty => fleetLoyalty.id);
    if (fleetsToCreate.length) {
      try {
        await this.vehicleService.createCompanyFleetLoyalty(fleetsToCreate).toPromise();
      } catch (error) {
        return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    }
    if (fleetsToUpdate.length) {
      try {
        await this.vehicleService.updateCompanyFleetLoyalty(fleetsToUpdate).toPromise();
      } catch (error) {
        if (fleetsToCreate.length) {
          this.refreshList.emit();
          this.initFleetLoyaltyForm();
        }
        return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    }
    this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
    this.refreshList.emit();
    this.initFleetLoyaltyForm();
  }

  get isPrincipalCompany(): boolean {
    return !!(this.listCompanies.length && this.company && this.company.companyId && this.listCompanies.some(company => company.nit === this.company.companyId));
  }

  onSubmitResume() {
    this.formResume.markAllAsTouched();
    const deactivateResumeObserver = {
      next: () => {
        this.spinner.hide();
        if (this.company && this.formResume) this.company.allowCreatingWithoutTruora = !this.formResume.value.allowCreatingWithoutTruora;
        this.updateSecurityStudyControlsState();
        this.refreshList.emit();
        if (this.formResume && this.formResume.value && this.formResume.value.allowCreatingWithoutTruora)
          this.snackBarService.openSnackBar("Se activó el estudio de seguridad correctamente.");
        else
          this.snackBarService.openSnackBar("Se desactivó el estudio de seguridad correctamente.");
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      },
      complete: () => {
        this.spinner.hide();
      }
    };
    this.spinner.show();
    this.companyService.setResume(this.company.companyId, !this.formResume.value.allowCreatingWithoutTruora).subscribe(deactivateResumeObserver);
  }

  onSubmitIntegration() {
    const value = this.formIntegration.get('monitor').value;

    const req = { companyId: this.company.companyId, status: (value ? 'ACTIVE' : 'INACTIVE') }

    this.companyService.setMonitorState(req).subscribe(
      () => {
        this.snackBarService.openSnackBar("Cambio guardado correctamente.", "Aceptar");
        this.refreshList.emit();
      },
      () => this.snackBarService.openSnackBar("Ha ocurrido un error.", "Aceptar", "error")

    );
  }

  /**
  * @returns {boolean} Returns true if the user's SaaS company has escort services
  * @description Verifies if the user's SaaS company has escort services
  */
  get hasEscortServicesCompany(): boolean {
    return this.authService && this.authService.hasEscortServicesCompany;
  }


  get hasTransportServicesCompany(): boolean {
    return this.authService && this.authService.hasTransportServicesCompany;
  }


  get isSecurityStudyRequired(): boolean {
    return !!(
      this.company &&
      this.utils.isDefined(this.company.allowCreatingWithoutTruora) &&
      !this.company.allowCreatingWithoutTruora
    );
  }

  hasValidationRules(role: Roles): boolean {
    return this.rules && this.rules.length && this.rules.some(rule => rule && rule.roleName === role);
  }

  onSubmitSecurityPolicies() {
    const policies: { [key in Roles.ADMIN | Roles.DRIVER | Roles.OWNER]: SecurityRules } = this.formSecurityPolicies.getRawValue();
    let body: ValidationRule[] = [];
    this.entitiesFields.forEach((entity: Roles) => {
      this.stateFields.forEach((state) => {
        if (policies[entity] && policies[entity] && this.utils.isDefined(policies[entity]['state'][state])) {
          const stateRule: ValidationRule = this.rules.find(rule => rule && rule.roleName === entity && rule.ruleType === 'state' && rule.ruleName === state);
          if (stateRule && stateRule.id) {
            stateRule['active'] = policies[entity]['state'][state];
            body.push(stateRule);
          }
        }
      })
      this.securityFields.forEach((security) => {
        if (policies[entity] && policies[entity] && this.utils.isDefined(policies[entity]['security'][security])) {
          const securityRule: ValidationRule = this.rules.find(rule => rule && rule.roleName === entity && rule.ruleType === 'security' && rule.ruleName === security);
          if (securityRule && securityRule.id) {
            securityRule['active'] = policies[entity]['security'][security];
            body.push(securityRule);
          }
        }
      })
    });
    this.spinner.show();
    this.companyService.updatePolicies(body).subscribe(() => {
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_SUCCESS, 'x', 'success')
      this.initSecurityPolicyForm();
    }, () => {
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, 'x', 'error')
    });
  }


  onChangeMonitor(active: boolean) {
    if (active) {
      const config = new MatDialogConfig();
      config.data = {
        title: `¿Seguro desea activar la trazabilidad con múltiples GPS?`,
        description: `Recuerde que este servicio tiene costo adicional.`,
        labelButton1: 'Cancelar',
        labelButton2: 'Activar',
        hideBtnCancel: true,
        hideBtnConfirm: true,
      };
      config.maxHeight = ModalEnum.MAX_HEIGHT;
      config.width = ModalEnum.SMALL_WIDTH;
      config.maxWidth = ModalEnum.MAX_WIDTH;
      config.autoFocus = false;
      this.dialog
        .open(DialogComponent, config)
        .afterClosed()
        .subscribe(
          (result) => {
            if (result.refuse !== 'Activar') {
              this.formIntegration.get('monitor').setValue(false);
            } else {
              this.onSubmitIntegration();
            }
          }
        )
    } else {
      this.onSubmitIntegration();
    }
  }

  onChangeActiveDocument(document: FormGroup) {
    if (document && document.get('active') && document.get('mandatory')) {
      if (!document.get('active').value) {
        document.get('mandatory').setValue(false);
        document.get('mandatory').disable();
      } else document.get('mandatory').enable();
    }

  }

  onSubmitVehicleDocuments() {
    this.spinner.show();
    this.companyService.setRequiredVehicleDocuments(this.formVehicleDocuments.getRawValue()).subscribe(
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS);
        this.refreshList.emit();
      },
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error")
      }
    );
  }

  async onSubmitPublicationByDefault() {
    let setting: Setting = this.formPublicationByDefault.getRawValue();
    const changeSettingSaasCompanyObserver = {
      next: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        this.authService.setSettingsSaasCompany();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      }
    }
    this.spinner.show();
    this.authService.changeSettingsSaasCompany(setting).subscribe(changeSettingSaasCompanyObserver);
  }

  async onSubmitInspection(type: 'containerInspection' | 'vehicleInspection') {
    const inspection: { active: string, id: string } = type === 'containerInspection'
      ? this.formContainerInspection.getRawValue()
      : this.formVehicleInspection.getRawValue();

    const companySettings = this.authService.getSettingsSaasCompany();
    const containerInspectionByDocument = companySettings.find(setting => setting.id === SettingId.ENABLE_CONTAINER_INSPECTION_BY_DOCUMENT);
    const containerInspectionByForm = companySettings.find(setting => setting.id === SettingId.ENABLE_CONTAINER_INSPECTION_BY_FORM);
    const vehicleInspectionByDocument = companySettings.find(setting => setting.id === SettingId.ENABLE_VEHICLE_INSPECTION_BY_DOCUMENT);
    const vehicleInspectionByForm = companySettings.find(setting => setting.id === SettingId.ENABLE_VEHICLE_INSPECTION_BY_FORM);

    const settingsToUpdate: { [key: string]: Setting } = {};
    if (type === 'containerInspection') {
      settingsToUpdate['document'] = containerInspectionByDocument;
      settingsToUpdate['form'] = containerInspectionByForm;
    } else {
      settingsToUpdate['document'] = vehicleInspectionByDocument;
      settingsToUpdate['form'] = vehicleInspectionByForm;
    }

    if (inspection.active === 'Ambos') {
      settingsToUpdate['document'].active = true;
      settingsToUpdate['form'].active = true;
    } else if (inspection.active === 'Documento') {
      settingsToUpdate['document'].active = true;
      settingsToUpdate['form'].active = false;
    } else if (inspection.active === 'Formulario') {
      settingsToUpdate['document'].active = false;
      settingsToUpdate['form'].active = true;
    }

    this.spinner.show();
    try {
      await Promise.all(Object.values(settingsToUpdate).map(setting => this.authService.changeSettingsSaasCompany(setting).toPromise()));
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
      this.authService.setSettingsSaasCompany();
    } catch (error) {
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    } finally {
      this.spinner.hide();
    }
  }

  get hasPermissionToIntegrateMonitor(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.setupMonitorIntegration
    );
  }

  get hasPermissionToEditTransportCompanyPolicy(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.updateCompany
    );
  }

  get hasPermissionToTruora(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.truoraConfiguration
    );
  }

  get hasPermissionEditVehicleDocuments(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.vehicleDocumentsConfiguration
    )
  }

  get hasPermissionEditAdditionalServicesUtilities(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.editAdditionalServicesUtilities
    )
  }

  get hasPermissionToChangeFeeToOwnedFleet(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.changeFeeToOwnedFleet
    );
  }

  get hasPermissionToChangeFleetLoyalty(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.changeFleetLoyalty
    );
  }

  get hasFastPaymentEnabled(): boolean {
    return !!this.company.fastPaymentEnabled;
  }
  get hasAppUsageDiscountEnabled(): boolean {
    return !!this.company.appUsageDiscountEnabled;
  }

  get hasPermissionValidationRule(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.changeValidationRules
    )
  }

  get hasPermissionRouteDetour(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.routeDetourConfiguration
    );
  }

  get hasPermissionTransportCompanyBlackList(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.transportCompanyBlackListConfiguration
    );
  }

  get hasPermissionRequiresPreValidation(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.requiresPreValidation
    );
  }

  get hasPermissionPrebillRequiresValidation(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.prebillRequiresValidation
    );
  }

  onChangeActiveRouteDetour(event: MatButtonToggleChange | any) {
    const active = this.utils.isDefined(event.value) ? event.value : event.checked;
    if (this.formRouteDetour) {
      if (active) this.formRouteDetour.get('metters').enable();
      else {
        this.formRouteDetour.get('metters').disable();
        this.formRouteDetour.get('metters').setValue(0);
      }
    }
  }

  onSubmitRouteDetour() {
    if (!this.formRouteDetour) return;
    this.formRouteDetour.markAllAsTouched();
    if (this.formRouteDetour.invalid) {
      if (this.utils.errorMessagesCustomized(this.formRouteDetour.get('metters'), 'metros', null, null, 1)) return;
      this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT);
      return;
    }
    const value = this.formRouteDetour.getRawValue();
    const body: ConfigurationSaaS = {
      id: ConfigurationSaaSId.ROUTE_DETOUR,
      data: {
        active: !!value.active,
        metters: Number(value.metters),
      },
    };
    const observer = {
      next: async () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        await this.authService.setConfigurationsSaasCompany();
        this.initRouteDetourForm();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      },
    };
    this.spinner.show();
    this.authService.changeConfigurationSaasCompany(body).subscribe(observer);
  }

  get filteredTransportCompanies(): CatalogItem[] {
    const value = this.transportCompanySearchControl.value;
    const term = value && typeof value === 'string' ? value.toLowerCase().trim() : '';
    const selectedIds = this.transportCompanyBlackList.map(item => item.id);
    return this.transportCompanyCatalog.filter(item => {
      if (!item || !item.id || selectedIds.indexOf(item.id) !== -1) return false;
      if (!term) return true;
      const name = item.name ? item.name.toLowerCase() : '';
      const id = item.id.toLowerCase();
      return name.indexOf(term) !== -1 || id.indexOf(term) !== -1;
    });
  }

  displayTransportCompanyName = (item?: CatalogItem | string): string => {
    if (!item) return '';
    return typeof item === 'string' ? item : (item.name || item.id || '');
  };

  onSelectTransportCompanyBlackList(event: MatAutocompleteSelectedEvent) {
    const selected: CatalogItem = event && event.option ? event.option.value : null;
    if (selected && selected.id) {
      const exists = this.transportCompanyBlackList.some(item => item.id === selected.id);
      if (!exists) {
        this.transportCompanyBlackList = this.transportCompanyBlackList.concat([{ id: selected.id, name: selected.name }]);
      }
    }
    this.transportCompanySearchControl.setValue('');
  }

  removeTransportCompanyFromBlackList(item: CatalogItem) {
    if (!item || !item.id) return;
    this.transportCompanyBlackList = this.transportCompanyBlackList.filter(company => company.id !== item.id);
  }

  trackByCatalogItemId(_index: number, item: CatalogItem): string {
    return item && item.id ? item.id : String(_index);
  }

  onSubmitTransportCompanyBlackList() {
    const body: ConfigurationSaaS = {
      id: ConfigurationSaaSId.TRANSPORT_COMPANY_BLACK_LIST,
      data: {
        list: this.transportCompanyBlackList
      }
    };
    const observer = {
      next: async () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
        await this.authService.setConfigurationsSaasCompany();
        this.initTransportCompanyBlackListForm();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    };
    this.spinner.show();
    this.authService.changeConfigurationSaasCompany(body).subscribe(observer);
  }

  get hasPermissionRiskProfile(): boolean {
    return this.permissionRole.hasPermission(
      Permission.administration.module,
      Permission.administration.riskProfileConfiguration
    );
  }

  private initRiskProfileForm() {
    const settings = this.riskProfileService.settings;
    this.riskProfileConfigExists = !!this.authService.getConfigurationsSaasCompany()
      .find(config => config && config.id === ConfigurationSaaSId.RISK_PROFILE);
    this.savedRiskThreshold = settings.threshold || null;
    this.savedRiskMediumThreshold = settings.mediumThreshold || null;
    this.savedTripsRequiredMedium = settings.tripsRequiredMedium || null;
    this.savedTripsRequiredHigh = settings.tripsRequiredHigh || null;
    this.savedRiskProfileEnabled = this.riskProfileService.enabled;
    this.formRiskProfile = new FormGroup({
      enabled: new FormControl(this.savedRiskProfileEnabled),
      threshold: new FormControl(this.savedRiskThreshold || this.DEFAULT_RISK_PROFILE_THRESHOLD, [Validators.required, Validators.min(1)]),
      mediumThreshold: new FormControl(this.savedRiskMediumThreshold, [Validators.min(1), this.mediumBelowHighValidator]),
      tripsRequiredMedium: new FormControl(this.savedTripsRequiredMedium, [Validators.min(1)]),
      tripsRequiredHigh: new FormControl(this.savedTripsRequiredHigh, [Validators.min(1)]),
    });
    this.syncRiskProfileEnabledAvailability();
    this.formRiskProfile.get('enabled').valueChanges.subscribe(() => this.syncRiskProfileEnabledAvailability());
    this.formRiskProfile.get('threshold').valueChanges.subscribe(() => this.syncMediumThresholdAvailability());
    this.formRiskProfile.get('mediumThreshold').valueChanges.subscribe(() => this.updateRiskValueBands());
    this.loadCompaniesRiskProfile();
  }

  /**
   * Los inputs con currencyMask emiten el string enmascarado ("10.000.000") en
   * valueChanges, mientras la directiva escribe el número con { emitEvent: false }.
   * Aquí puede llegar cualquiera de los dos, y Number() sobre el string agrupado
   * da NaN (varios puntos) o una magnitud equivocada (un punto leído como decimal).
   */
  private riskAmount(value: string | number): number {
    if (value === null || value === undefined || value === '') return 0;
    return this.utils.normalizeValueCurrencyMask(value);
  }

  private mediumBelowHighValidator = (control: AbstractControl) => {
    const group = control.parent;
    if (!group) return null;
    const high = this.riskAmount(group.get('threshold').value);
    const medium = this.riskAmount(control.value);
    return medium && high && medium >= high ? { notBelowHigh: true } : null;
  };

  /**
   * Con el interruptor maestro apagado, ninguno de los campos configurables (umbrales, tipos de
   * viaje de riesgo bajo, viajes mínimos) tiene efecto en backend, así que quedan deshabilitados
   * visualmente. `mediumThreshold` sigue su propia regla (depende de `threshold`) vía
   * {@link canConfigureMediumThreshold}, que ya respeta el interruptor.
   */
  private syncRiskProfileEnabledAvailability() {
    const masterEnabled = !!this.formRiskProfile.get('enabled').value;
    [
      this.formRiskProfile.get('threshold'),
      this.formRiskProfile.get('tripsRequiredHigh'),
      this.formRiskProfile.get('tripsRequiredMedium'),
    ].forEach(control => {
      if (masterEnabled) { if (control.disabled) control.enable({ emitEvent: false }); }
      else if (control.enabled) control.disable({ emitEvent: false });
    });
    this.syncMediumThresholdAvailability();
  }

  private syncMediumThresholdAvailability() {
    const mediumControl = this.formRiskProfile.get('mediumThreshold');
    if (this.canConfigureMediumThreshold) {
      if (mediumControl.disabled) mediumControl.enable({ emitEvent: false });
      mediumControl.updateValueAndValidity({ emitEvent: false });
    } else if (mediumControl.enabled) {
      mediumControl.setValue(null, { emitEvent: false });
      mediumControl.disable({ emitEvent: false });
    }
    this.updateRiskValueBands();
  }

  get canConfigureMediumThreshold(): boolean {
    return !!this.formRiskProfile && !!this.formRiskProfile.get('enabled').value
      && this.riskAmount(this.formRiskProfile.get('threshold').value) >= 1;
  }

  get mediumThresholdValue(): number {
    if (!this.formRiskProfile) return null;
    const value = this.riskAmount(this.formRiskProfile.get('mediumThreshold').value);
    return this.canConfigureMediumThreshold && value > 0 ? value : null;
  }

  /**
   * Sin umbral medio configurado ningún servicio queda en riesgo medio, así que exigirle viajes a ese
   * perfil no tendría efecto. Espeja la regla de perfiles disponibles (`RiskProfileService`).
   */
  get canConfigureTripsRequiredMedium(): boolean {
    return !!this.mediumThresholdValue;
  }

  /** Viajes exigidos para riesgo medio, descartados si el perfil medio no es alcanzable. */
  get tripsRequiredMediumValue(): number {
    if (!this.formRiskProfile || !this.canConfigureTripsRequiredMedium) return null;
    return Number(this.formRiskProfile.get('tripsRequiredMedium').value) || null;
  }

  private updateRiskValueBands() {
    const high = this.riskAmount(this.formRiskProfile.get('threshold').value) || null;
    /* Con el campo de riesgo medio en error el valor no describe un rango válido
       (p. ej. medio >= alto daría "mayor o igual a $X y menor a $X"): se omite la banda. */
    const medium = this.formRiskProfile.get('mediumThreshold').invalid ? null : this.mediumThresholdValue;
    if (!high) {
      this.riskValueBands = [{ bucket: 'low', label: this.riskBucketLabels.low, description: 'Cualquier valor declarado, mientras no haya un valor configurado' }];
    } else if (!medium) {
      this.riskValueBands = [
        { bucket: 'low', label: this.riskBucketLabels.low, description: `Menor a ${this.riskCurrency(high)}` },
        { bucket: 'high', label: this.riskBucketLabels.high, description: `Mayor o igual a ${this.riskCurrency(high)}` },
      ];
    } else {
      this.riskValueBands = [
        { bucket: 'low', label: this.riskBucketLabels.low, description: `Menor a ${this.riskCurrency(medium)}` },
        { bucket: 'medium', label: this.riskBucketLabels.medium, description: `Mayor o igual a ${this.riskCurrency(medium)} y menor a ${this.riskCurrency(high)}` },
        { bucket: 'high', label: this.riskBucketLabels.high, description: `Mayor o igual a ${this.riskCurrency(high)}` },
      ];
    }
  }

  private riskCurrency(value: number): string {
    return `$${this.utils.formatStorageValues(String(value))}`;
  }

  get hasRiskProfileEdits(): boolean {
    return !!this.formRiskProfile && (this.formRiskProfile.dirty || this.hasPendingRiskMoves);
  }

  get hasPendingRiskMoves(): boolean {
    return this.riskBuckets.some(bucket => !!this.pendingRiskIds[bucket].size);
  }

  get hasRiskProfileChanges(): boolean {
    return !!this.formRiskProfile && (this.hasRiskProfileEdits || !this.riskProfileConfigExists);
  }

  private loadCompaniesRiskProfile() {
    this.loadingRiskCompanies = true;
    this.selectCompanyService.getAllCompanies().subscribe(
      (companies: Company[]) => {
        this.allRiskCompanies = (companies || []).filter(company => company && company.companyId)
          .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        this.originalRiskBucketById = {};
        this.allRiskCompanies.forEach(company => this.originalRiskBucketById[company.companyId] = this.savedRiskBucketOf(company));
        this.resetRiskProfileLists();
        this.loadingRiskCompanies = false;
      },
      () => {
        this.loadingRiskCompanies = false;
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    );
  }

  private savedRiskBucketOf(company: Company): RiskBucket {
    return this.RISK_BUCKET_BY_ID[this.utils.getNestedValue(company, 'riskProfile.id')] || 'low';
  }

  private resetRiskProfileLists() {
    this.riskBuckets.forEach(bucket => {
      this.riskCompanies[bucket] = [];
      this.riskSelectedIds[bucket].clear();
      this.pendingRiskIds[bucket].clear();
    });
    this.allRiskCompanies.forEach(company => this.riskCompanies[this.originalRiskBucketById[company.companyId]].push(company));
    this.applyRiskFilters();
  }

  discardRiskProfileChanges() {
    this.formRiskProfile.get('threshold').setValue(this.savedRiskThreshold || this.DEFAULT_RISK_PROFILE_THRESHOLD);
    this.formRiskProfile.get('mediumThreshold').setValue(this.savedRiskMediumThreshold);
    this.formRiskProfile.get('tripsRequiredMedium').setValue(this.savedTripsRequiredMedium);
    this.formRiskProfile.get('tripsRequiredHigh').setValue(this.savedTripsRequiredHigh);
    this.syncMediumThresholdAvailability();
    this.formRiskProfile.markAsPristine();
    this.resetRiskProfileLists();
  }

  onRiskSearchChange() {
    this.applyRiskFilters();
  }

  clearRiskSearch(bucket: RiskBucket) {
    this.riskSearch[bucket] = '';
    this.applyRiskFilters();
  }

  private applyRiskFilters() {
    this.riskBuckets.forEach(bucket => this.filteredRiskCompanies[bucket] =
      this.filterCompaniesByText(this.riskCompanies[bucket], this.riskSearch[bucket]));
    this.refreshRiskViewports();
  }

  private filterCompaniesByText(companies: Company[], text: string): Company[] {
    if (!text || !text.trim()) return companies.slice();
    const term = text.trim().toLowerCase();
    return companies.filter(company =>
      (company.name && company.name.toLowerCase().includes(term)) ||
      (company.companyId && company.companyId.toLowerCase().includes(term)));
  }

  isRiskSelected(bucket: RiskBucket, company: Company): boolean {
    return this.riskSelectedIds[bucket].has(company.companyId);
  }

  isRiskPending(company: Company): boolean {
    return this.riskBuckets.some(bucket => this.pendingRiskIds[bucket].has(company.companyId));
  }

  toggleRiskCompany(bucket: RiskBucket, company: Company) {
    const selectedIds = this.riskSelectedIds[bucket];
    selectedIds.has(company.companyId) ? selectedIds.delete(company.companyId) : selectedIds.add(company.companyId);
  }

  allFilteredRiskSelected(bucket: RiskBucket): boolean {
    const companies = this.filteredRiskCompanies[bucket];
    return !!companies.length && companies.every(company => this.riskSelectedIds[bucket].has(company.companyId));
  }

  toggleSelectAllRisk(bucket: RiskBucket) {
    const companies = this.filteredRiskCompanies[bucket];
    const selectedIds = this.riskSelectedIds[bucket];
    const shouldSelect = !this.allFilteredRiskSelected(bucket);
    companies.forEach(company => shouldSelect ? selectedIds.add(company.companyId) : selectedIds.delete(company.companyId));
  }

  get selectedRiskCount(): number {
    return this.riskBuckets.reduce((total, bucket) => total + this.riskSelectedIds[bucket].size, 0);
  }

  riskMovableCount(target: RiskBucket): number {
    return this.riskBuckets.filter(bucket => bucket !== target)
      .reduce((total, bucket) => total + this.riskSelectedIds[bucket].size, 0);
  }

  moveSelectedRiskCompaniesTo(target: RiskBucket) {
    const companyIds: string[] = [];
    this.riskBuckets.filter(bucket => bucket !== target)
      .forEach(bucket => this.riskSelectedIds[bucket].forEach(companyId => companyIds.push(companyId)));
    this.moveRiskCompanies(companyIds, target);
  }

  private moveRiskCompanies(companyIds: string[], target: RiskBucket) {
    if (!companyIds || !companyIds.length || !target) return;
    const idsToMove = new Set(companyIds);
    const moved: Company[] = [];
    this.riskBuckets.filter(bucket => bucket !== target).forEach(bucket => {
      const companies = this.riskCompanies[bucket];
      for (let i = companies.length - 1; i >= 0; i--) {
        if (!idsToMove.has(companies[i].companyId)) continue;
        const company = companies.splice(i, 1)[0];
        this.riskSelectedIds[bucket].delete(company.companyId);
        moved.push(company);
      }
    });
    if (!moved.length) return;
    moved.forEach(company => {
      this.riskCompanies[target].push(company);
      this.trackRiskProfileChange(company.companyId, target);
    });
    this.riskCompanies[target].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    this.applyRiskFilters();
  }

  private trackRiskProfileChange(companyId: string, target: RiskBucket) {
    this.riskBuckets.forEach(bucket => this.pendingRiskIds[bucket].delete(companyId));
    if (this.originalRiskBucketById[companyId] !== target) this.pendingRiskIds[target].add(companyId);
  }

  refreshRiskViewports() {
    if (!this.riskViewports) return;
    setTimeout(() => this.riskViewports.forEach(viewport => viewport.checkViewportSize()));
  }

  onConfigTabChange() {
    this.refreshRiskViewports();
  }

  async onSubmitRiskProfile() {
    this.formRiskProfile.markAllAsTouched();
    if (this.formRiskProfile.invalid) {
      const mediumControl = this.formRiskProfile.get('mediumThreshold');
      if (mediumControl.errors && mediumControl.errors.notBelowHigh) {
        this.snackBarService.openSnackBar('El valor para riesgo medio debe ser menor al valor para riesgo alto', undefined, 'alert');
        return;
      }
      if (this.utils.errorMessagesCustomized(this.formRiskProfile.get('threshold'), 'valor para riesgo alto', null, null, 1)) return;
      this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT);
      return;
    }
    const mediumThreshold = this.mediumThresholdValue;
    if (!this.hasRiskProfileChanges) return;
    const threshold = this.riskAmount(this.formRiskProfile.get('threshold').value);
    const tripsRequiredMedium = this.tripsRequiredMediumValue;
    const tripsRequiredHigh = Number(this.formRiskProfile.get('tripsRequiredHigh').value) || null;
    const enabled = !!this.formRiskProfile.get('enabled').value;
    const configBody: ConfigurationSaaS = {
      id: ConfigurationSaaSId.RISK_PROFILE,
      enabled,
      data: {
        threshold, mediumThreshold, tripsRequiredMedium, tripsRequiredHigh
      } as RiskProfileConfigData,
    };
    const bulkBody: RiskProfileBulkBody = {
      highRiskCompanyIds: Array.from(this.pendingRiskIds.high),
      mediumRiskCompanyIds: Array.from(this.pendingRiskIds.medium),
      lowRiskCompanyIds: Array.from(this.pendingRiskIds.low),
    };
    this.spinner.show();
    try {
      const requests: Promise<any>[] = [
        (this.riskProfileConfigExists
          ? this.authService.changeConfigurationSaasCompany(configBody)
          : this.authService.createConfigurationSaasCompany(configBody)).toPromise(),
      ];
      if (this.hasPendingRiskMoves) requests.push(this.companyService.updateRiskProfileBulk(bulkBody).toPromise());
      await Promise.all(requests);
      this.riskProfileConfigExists = true;
      this.savedRiskProfileEnabled = enabled;
      this.savedRiskThreshold = threshold;
      this.savedRiskMediumThreshold = mediumThreshold;
      this.savedTripsRequiredMedium = tripsRequiredMedium;
      this.savedTripsRequiredHigh = tripsRequiredHigh;
      this.riskBuckets.forEach(bucket => this.pendingRiskIds[bucket]
        .forEach(companyId => this.originalRiskBucketById[companyId] = bucket));
      this.riskBuckets.forEach(bucket => this.pendingRiskIds[bucket].clear());
      this.formRiskProfile.markAsPristine();
      await this.authService.setConfigurationsSaasCompany();
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_UPDATE_SUCCESS, undefined, 'success');
    } catch (error) {
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    }
  }

  get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany() && this.authService.getCompany().companyId === environment.rootNit;
  }

  get hasPermissionPaymentDispersion(): boolean {
    // El archivo PAB solo aplica a los métodos de pago que generan archivo de dispersión bancaria.
    // Se excluye LoggiCash (loggiapp), que no produce archivo PAB sino que envía el pago a la fintech.
    const paymentGenerationFunctionalities = [
      Permission.payments.paymentAdvance,
      Permission.payments.unrestrictedAdvancePayments,
      Permission.payments.paymentBalance,
      Permission.payments.paymentAdditionalCosts,
      Permission.payments.paymentExtraAdvance,
      Permission.payments.paymentTravelExpenses,
    ];
    return paymentGenerationFunctionalities.some(functionality =>
      this.permissionRole.hasPermission(Permission.payments.module, functionality)
    );
  }

  get hasSiigoIntegration(): boolean {
    return this.authService && this.authService.getCompanySaaS().integrationCredentials &&
      this.authService.getCompanySaaS().integrationCredentials.length &&
      this.authService.getCompanySaaS().integrationCredentials.some(integration => integration && integration.integrationChannel
        && integration.integrationChannel.toLowerCase() === IntegrationEnum.SIIGO.toLowerCase() && integration.state);
  }

  onTabsChange(event: MatTabChangeEvent): void {
    const key = event && event.tab ? this.tabKeyByLabel[event.tab.textLabel] : null;
    this.refreshRiskViewports();
    if (key) this.loadTab(key);
  }

  loadTab(key: string, force = false): void {
    const state = this.tabState[key];
    if (!state || state.loading) return;
    if (state.loaded && !force) return;
    state.loading = true;
    state.error = false;
    this.runTabLoad(key, force)
      .then(() => { state.loaded = true; })
      .catch(() => { state.error = true; })
      .then(() => { state.loading = false; });
  }

  refreshTab(key: string): void {
    this.loadTab(key, true);
  }

  private async runTabLoad(key: string, force: boolean): Promise<void> {
    switch (key) {
      case 'OperationAndTracking':
        if (force) {
          await this.authService.refreshSettingsSaasCompany();
          await this.authService.setConfigurationsSaasCompany();
          this.getSaasSettings();
          this.initRouteDetourForm();
        }
        break;
      case 'Security':
        if (force) {
          await this.initSecurityPolicyForm();
          await this.authService.setConfigurationsSaasCompany();
          this.initTransportCompanyBlackListForm();
        }
        break;
      case 'VehiclesAndDrivers':
        await this.loadVehiclesData();
        break;
      case 'BillingAndPayments':
        await this.getConsecutives();
        // Con servicios de transporte la facturación Siigo es por empresa y vive en "Empresas de transporte".
        if (!this.hasTransportServicesCompany) await this.getServicesAsync();
        const billingSections = this.tabsAndSectionsToShow['BillingAndPayments'];
        if (billingSections && billingSections['additionalServicesUtilities']) await this.loadBasicAdditionalServices();
        await this.loadWhoToPays();
        break;
      case 'RiskProfile':
        this.refreshRiskViewports();
        break;
      case 'TransportCompanies':
        await this.loadTransportCompanies();
        if (force) {
          this.billingSectionLoadedFor = null;
          if (this.billingSectionExpanded) await this.loadBillingSection();
          this.accountingSectionLoadedFor = null;
          if (this.accountingSectionExpanded) await this.loadAccountingSection();
        }
        break;
    }
  }

  private async loadTransportCompanies(): Promise<void> {
    const companies = await this.companyService.getSaasTransportCompanies().toPromise();
    this.transportCompanies = companies || [];
    // La empresa elegida en la pastilla puede resolverse antes de que llegue el listado.
    this.initTransportCompanyBillingConfiguration();
  }

  /**
   * Tipo de documento de la empresa de transporte elegida, tal como viene en el
   * listado de empresas (billingConfiguration.documentTypeId). Sin configurar
   * queda vacío: no se usa el valor histórico de la SaaS, que no es de la empresa.
   */
  private initTransportCompanyBillingConfiguration(): void {
    if (!this.hasTransportServicesCompany) return;
    const transportCompany = this.selectedTransportCompany;
    const documentType = transportCompany && transportCompany.billingConfiguration && transportCompany.billingConfiguration.documentTypeId;
    this.typeBill = documentType && documentType.code
      ? { code: String(documentType.code), description: documentType.description }
      : { code: '', description: '' };
  }

  openTransportCompanyPolicyDialog(transportCompany: SaasTransportCompany): void {
    const config = new MatDialogConfig();
    config.data = { transportCompany };
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.autoFocus = false;

    this.dialog.open(SaasTransportCompanyPolicyFormComponent, config)
      .afterClosed()
      .subscribe(result => {
        if (result && result.updated) this.refreshTab('TransportCompanies');
      });
  }

  private async loadBasicAdditionalServices(): Promise<void> {
    try {
      // Sin empresa de transporte: trae utility y, en los servicios por actor, whoToPaysUtilities.
      this.basicAdditionalServices = await this.companyService.getAdditionalServices().toPromise() || [];
    } catch (error) {
      this.basicAdditionalServices = [];
    }
  }

  private async loadWhoToPays(): Promise<void> {
    try {
      this.billingWhoToPays = await this.companyService.getWhoToPays().toPromise() || [];
    } catch (error) {
      this.billingWhoToPays = [];
    }
  }

  public get tabsAndSectionsToShow(): { [key: string]: boolean } {
    const tabsToShow = {};
    const operationAndTracking = {
      routeDetour: !!(this.isPrincipalCompany && this.hasPermissionRouteDetour && this.formRouteDetour),
      satelliteTracking: !!(this.isPrincipalCompany && this.canEditSatelliteTracking && this.formSatelliteTracking),
      publicationByDefault: !!(this.isPrincipalCompany && this.hasTransportServicesCompany && this.formPublicationByDefault),
      useEvidenceToGuides: !!(this.isPrincipalCompany && this.hasPermissionToChangeFeeToOwnedFleet && this.formUseEvidenceToGuides && this.hasTransportServicesCompany),
      integrationMonitor: !!(this.isPrincipalCompany && this.hasPermissionToIntegrateMonitor),
      requiresPreValidation: !!(this.isPrincipalCompany && this.hasPermissionRequiresPreValidation && this.formRequiresPreValidation),
      prebillRequiresValidation: !!(this.isPrincipalCompany && this.hasPermissionPrebillRequiresValidation && this.formPrebillRequiresValidation),
    }
    const security = {
      securityPolicies: !!(this.isPrincipalCompany && this.hasPermissionValidationRule && this.rules && this.rules.length
        && (this.hasTransportServicesCompany || this.hasEscortServicesCompany)),
      transportCompanyBlackList: !!(this.isPrincipalCompany && this.hasTransportServicesCompany && this.hasPermissionTransportCompanyBlackList && this.transportCompanyCatalog.length),
    }
    const vehiclesAndDrivers = {
      vehicleDocuments: !!(this.isPrincipalCompany && this.hasPermissionEditVehicleDocuments && (this.hasTransportServicesCompany || this.hasEscortServicesCompany)),
      fleetLoyalty: !!(this.isPrincipalCompany && this.hasPermissionToChangeFleetLoyalty && (this.hasFastPaymentEnabled || this.hasAppUsageDiscountEnabled) && this.hasTransportServicesCompany),
      soatRtm: !!(this.hasTransportServicesCompany || this.hasEscortServicesCompany),
      daysToDeactivateVehicle: !!(this.isPrincipalCompany && this.formVehicle && (this.hasTransportServicesCompany || this.hasEscortServicesCompany)),
      vehicleInspection: !!(this.isPrincipalCompany && this.formVehicleInspection && (this.hasTransportServicesCompany || this.hasEscortServicesCompany)),
      containerInspection: !!(this.isPrincipalCompany && this.formContainerInspection && this.hasTransportServicesCompany),
      allowCreatingWithoutTruora: !!(this.isPrincipalCompany && this.hasPermissionToTruora && (this.hasTransportServicesCompany || this.hasEscortServicesCompany)),
      fees: !!(this.isPrincipalCompany && this.hasPermissionToChangeFeeToOwnedFleet && this.formFees && this.hasTransportServicesCompany),
    }
    const billingAndPayments = {
      // Con servicios de transporte se configuran por empresa en "Empresas de transporte" (billingSiigo).
      typeBill: !!(this.isPrincipalCompany && this.hasSiigoIntegration && !this.hasTransportServicesCompany),
      citiesSiigo: !!(this.isPrincipalCompany && this.hasSiigoIntegration && !this.hasTransportServicesCompany),
      additionalServicesSiigo: !!(this.isPrincipalCompany && this.hasSiigoIntegration && !this.hasTransportServicesCompany),
      costCenterSiigo: !!(this.isPrincipalCompany && this.hasSiigoIntegration),
      enableType12InvoiceSiigo: !!(this.isPrincipalCompany && this.hasSiigoIntegration),
      accountingSiigo: !!(this.isPrincipalCompany && this.hasSiigoIntegration),
      additionalServicesUtilities: !!(this.isPrincipalCompany && this.hasPermissionEditAdditionalServicesUtilities && this.hasTransportServicesCompany),
    }
    const riskProfile = {
      configuration: !!(this.isPrincipalCompany && this.hasPermissionRiskProfile && this.formRiskProfile),
    }
    const payments = {
      paymentConsolidation: !!(this.isPrincipalCompany && this.hasPermissionPaymentDispersion && this.formPaymentConsolidation),
    }
    const transportCompanies = {
      // Solo una SaaS con servicios de transporte tiene transportadoras que listar.
      list: !!(this.isPrincipalCompany && this.hasTransportServicesCompany),
      // Tipo de documento y productos Siigo por empresa de transporte.
      billingSiigo: !!(this.isPrincipalCompany && this.hasSiigoIntegration && this.hasTransportServicesCompany),
    }
    if (Object.values(operationAndTracking).some(value => value))
      tabsToShow['OperationAndTracking'] = operationAndTracking;
    if (Object.values(security).some(value => value))
      tabsToShow['Security'] = security;
    if (Object.values(vehiclesAndDrivers).some(value => value))
      tabsToShow['VehiclesAndDrivers'] = vehiclesAndDrivers;
    if (Object.values(billingAndPayments).some(value => value))
      tabsToShow['BillingAndPayments'] = billingAndPayments;
    if (Object.values(riskProfile).some(value => value))
      tabsToShow['RiskProfile'] = riskProfile;
    if (Object.values(payments).some(value => value))
      tabsToShow['Payments'] = payments;
    if (Object.values(transportCompanies).some(value => value))
      tabsToShow['TransportCompanies'] = transportCompanies;
    return tabsToShow;
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    if (this.citySub) this.citySub.unsubscribe();
  }
}
